import { render, staticRenderFns } from "./AddRGBStandAlone.vue?vue&type=template&id=46a11138"
import script from "./AddRGBStandAlone.vue?vue&type=script&lang=js"
export * from "./AddRGBStandAlone.vue?vue&type=script&lang=js"
import style0 from "./AddRGBStandAlone.vue?vue&type=style&index=0&id=46a11138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports